import "./ProductQuality.scss";

const ProductQuality = () => {
  return (
    <div className="product-quality">
      <section>
        <div>
          <div className="img-container">
            <div className="image-container">
              <img
                src="/images/about/product-quality.png"
                alt="product-quality"
              />
            </div>
          </div>
          <div id="info">
            <div>
              <div id="title">
                <div className="line" />
                <p>Des produits de qualité</p>
              </div>
              <p>
                Notre catalogue de produits est défini minutieusement pour
                répondre aux exigences de vos métiers et pour satisfaire vos
                attentes en terme de responsabilité sociale et écologique.
                <br />
                <br />
                SP Hygiène a développé des partenariats avec les plus grandes
                marques afin de pouvoir vous proposer des produits de qualité
                et  respectueux de vos valeurs.
                <br />
                <br />
                Du papier hygiénique aux autolaveuses, en passant par les
                nettoyants parquets, sanitaires, cuisine et métaux, nos nombreux
                fournisseurs sont minutieusement sélectionnés pour une fiabilité
                optimale. Nos partenaires nous permettent aujourd'hui de vous
                proposer une gamme de produits complète pour une maîtrise totale
                de l'hygiène pour votre entreprise.
                <br />
                <br />
                L'entreprise est adhérent du groupement Equipage depuis 2015,
                bénéficiant ainsi de relations privilégiées avec les meilleurs
                fournisseurs  européens, sur des milliers de produits et
                matériels d'hygiène référencés.
              </p>
            </div>
            <div className="button-div">
              <button>Passer commande</button>
              <button>Nous contacter</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductQuality;
